module.exports = __webpack_public_path__ + "static/media/team-member-05.6cfdf588.jpg";